export const cl = {
  companyName: "Metagrad Consultancy",
  invoiceNumber: "INV-2026-001",
  workOrder: "WO-7788",
  date: "15/01/2026",

  clientName: "ABC Pvt Ltd",
  customerId: "CUST-009",

  mailingInfo: {
    addressLine1: "123 Business Street",
    addressLine2: "Mumbai, MH 400001",
    phone: "+91 98765 43210",
  },

  billTo: {
    name: "ABC Pvt Ltd",
    customerId: "CUST-009",
    addressLine1: "Corporate Park, Andheri",
    addressLine2: "Mumbai, MH 400093",
  },

  hourlyServices: [
    { desc: "Consulting Work", hours: 10, rate: "₹500", amount: "₹5000" }
  ],

  otherServices: [
    { desc: "Documentation", amount: "₹1500" }
  ],

  subtotalHourly: "5000.00",
  subtotalOther: "1500.00",
  totalTax: "0.00",
  sh: "0.00",
  discount: "0.00",
  total: "6500.00",

  comments: [
    "Total payment due in 30 days",
    "Please include the invoice number on your check"
  ]
};
